import {
  BuildFilled,
  DeleteFilled,
  EditFilled,
  ExclamationCircleOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import paths from 'assets/routes/paths';
import useTenantFlags from 'hooks/useTenantFlags';
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Menú de acciones (⋯) de cada fila de la tabla de clientes.
// Activar/desactivar cliente y la preventiva automática ahora son Switches
// directos en columnas (ClientList.jsx); acá quedan edición, navegación a la
// ficha, ver avisos y eliminación.
const ClienteRowActions = ({ usuario, openEditClient, openDeleteClient, getClientProblems }) => {
  const navigate = useNavigate();
  const { readOnly } = useTenantFlags();

  // En tenants read-only solo se conservan las acciones de lectura
  // ("Ver datos" y "Ver avisos"); se ocultan editar y eliminar.
  const READ_ONLY_KEYS = ['data', 'problems'];

  const allItems = [
    {
      key: 'edit',
      icon: <EditFilled />,
      label: 'Editar cliente',
      onClick: () => openEditClient(usuario),
    },
    {
      key: 'data',
      icon: <BuildFilled />,
      label: 'Ver datos',
      onClick: () => navigate(paths.admin.clientes.detail(usuario.id)),
    },
    {
      key: 'problems',
      icon: <ExclamationCircleOutlined />,
      label: 'Ver avisos',
      disabled: !usuario.problems,
      onClick: () => getClientProblems(usuario),
    },
    { type: 'divider' },
    {
      key: 'delete',
      icon: <DeleteFilled />,
      label: 'Eliminar cliente',
      danger: true,
      onClick: () => openDeleteClient(usuario),
    },
  ];

  const items = readOnly ? allItems.filter((item) => READ_ONLY_KEYS.includes(item.key)) : allItems;

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Button type="text" icon={<MoreOutlined />} />
    </Dropdown>
  );
};

export default ClienteRowActions;
